'use client'

import { useMutation } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'
import { useTRPC } from '@/app/api/trpc/config'
import { buildNewsletterSignupEmail } from '@/frontend/_marketing/email-templates'
import { H3 } from '@/frontend/design-system/_marketing/typography/Heading'
import { P3 } from '@/frontend/design-system/_marketing/typography/Paragraph'
import { Button } from '@/frontend/design-system/actions/Button'
import { showErrorToastWithAlgoPhoneNumber } from '@/frontend/design-system/feedback/Toaster/ToasterError'
import { Input } from '@/frontend/design-system/forms/Input'

type NewsletterForm = {
  email: string
}

export function Newsletter() {
  const trpc = useTRPC()
  const sendEmailMutation = useMutation(trpc.notifications.sendEmails.mutationOptions())
  const { register, handleSubmit, reset } = useForm<NewsletterForm>()

  const onSubmit = async (data: NewsletterForm) => {
    try {
      await sendEmailMutation.mutateAsync({
        emailData: buildNewsletterSignupEmail(data.email)
      })

      await sendEmailMutation.mutateAsync({
        emailData: {
          subject: 'Newsletter',
          htmlContent: 'Dziękujemy za zapisanie się do naszego newslettera!',
          correspondents: {
            receiverEmails: [data.email]
          }
        }
      })
      toast.success('Udało się!', {
        description: 'Dziękujemy za zapisanie się do naszego newslettera!'
      })
      reset()
    } catch {
      showErrorToastWithAlgoPhoneNumber()
    }
  }

  return (
    <div className='space-y-4'>
      <H3>Śledź wieści na temat naszej platformy learningowej</H3>
      <P3>Zapisz się do naszego newslettera</P3>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className='flex flex-col items-center gap-4 lg:flex-row'
      >
        <Input
          placeholder='Email'
          type='email'
          {...register('email', { required: true })}
          className='h-full'
        />
        <Button size='xl' type='submit' className='w-full text-nowrap lg:w-fit'>
          Zapisz się
        </Button>
      </form>
    </div>
  )
}
